import { Component, OnInit } from '@angular/core';
import { NeproseService } from 'src/app/services/neprose.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-favourite',
  templateUrl: './favourite.component.html',
  styleUrls: ['./favourite.component.css']
})
export class FavouriteComponent implements OnInit {

  dataLoaded: boolean

  favouritePropertyList = []

  municipalityList = []

  constructor( private _neproseService: NeproseService, private route: ActivatedRoute, private _router: Router, private _notification: MatSnackBar ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { municipalityList: any})=> {
      this.municipalityList = data.municipalityList.municipalities
    })
    this.getFavouriteList()
  }

  getFavouriteList(){
    this._neproseService.getMyFavourites().subscribe(data => {
      this.dataLoaded = true
      if(data.favorite){
        let favouriteList = data.favorite
        for(let favourite of favouriteList){
          this.getProperty(favourite.property_id, favourite.id)
        }
      }
    })
  }

  getProperty(property_id, favourite_id){
    this._neproseService.getAdvertisement(property_id).subscribe(data => {
      if(data.status){
        let property = data.propertyAd
        property['featuredImage'] = null
        property['favourite_id'] = favourite_id
        if(property.PropertyImage){
          let propertyImages = JSON.parse(property.PropertyImage.imagePath)
          if(propertyImages.length > 0){
            property.featuredImage = environment.api+'/images/'+propertyImages[0]
          }
        }
        let municipality = this.municipalityList.find(municipality => municipality.id == property.municipality_id)
        let address = municipality.municipality
        if(property.village){
          address = property.village+', '+address
        }
        property['address'] = address
        this.favouritePropertyList.push(property)
      }
    })
  }

  viewProperty(id){
    this._router.navigate(['/property/'+id])
  }

  removeFromFavourite(id){
    this._neproseService.deleteFromFavourite(id).subscribe(data => {
      if(data.status){
        let property = this.favouritePropertyList.find(property => property.favourite_id == id)
        const index = this.favouritePropertyList.indexOf(property);
        if (index > -1) {
          this.favouritePropertyList.splice(index, 1);
          this.openNotification('Rmoved from favourite!')
        }
      }
    })
  }

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
